import React, { useState, useEffect } from 'react';
import * as FieldTypes from "./FieldTypes.js";

const UDITextField = ({
    UDI,
    setUDI,
    fieldTitle,
    fieldName,
    mandatory = null,
    string = null,
    numeric = null,
    min = null,
    max = null,
    forceIsEditing = null
}) => {

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [value, setValue] = useState(UDI?.[fieldName]);


    const handleChange = (e) => {
        let newValue = e.target.value;
        setValue(newValue);
        
        setUDI(prevItem => ({
            ...prevItem,
            [fieldName]: newValue
        }));

        validate(newValue);
    }

    // 0 is a real value, so don't use a falsy check
    const isEmpty = (val) => val === null || val === undefined || String(val).trim() === "";

    const validate = (val) => {

        setErrorVar(false);

        if (mandatory && isEmpty(val)) {
            setErrorVar(fieldTitle + " is mandatory");
            return;
        }


        if (numeric) {

            if (isNaN(val)) {
                setErrorVar(fieldTitle + " has to be numeric");
                return;
            }

            try {
                val = parseInt(val);

                if (!isNaN(val) && (min != null && val < min || max != null && val > max)) {
                    setErrorVar(fieldTitle + " has to be between " + min + " and " + max);
                    return;
                }

            }
            catch (ex) {
                setErrorVar(fieldTitle + " is invalid");
                return;
            }
        }


        if (string) {
            if (val && val != "" && (min != null && val.length < min || max != null && val.length > max)) {
                setErrorVar(fieldTitle + " length must be between " + min + " and " + max);
                return;
            }
        }

    }


    
    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    useEffect(() => {

        validate(value);

    }, [value]);
    
    

    return (
        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <div>
                            {isEditingField === false ? (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span
                                        className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                                        onClick={() => changeIsEditingField(true)}
                                    >
                                        {isEmpty(value) ?
                                            <FieldTypes.ItemDetailsField_EmptyValue />
                                            :
                                            value
                                        }
                                    </span>
                                </div>

                            ) : (
                                <span>
                                    <input
                                        className="form-control"
                                        onBlur={() => changeIsEditingField(false)}
                                        onChange={handleChange}
                                        value={value}
                                        autoFocus={forceIsEditing != null ? false : true}
                                    />
                                </span>
                            )}
                        </div>
                        <div>
                            {errorVar && (
                                <span className="form-field-error-message">
                                    {errorVar}
                                </span>
                            )}    
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default UDITextField;